export default __webpack_public_path__ + "static/media/pointblankshot.60019021.png";